import styled from '@emotion/styled'
import { rpMediaQueries } from '../../core/theme'

export const Container = styled.div<{ showPaymentsTable: boolean }>`
  gap: 13px;
  z-index: ${({ showPaymentsTable }) => (showPaymentsTable ? 10 : 10)};
`

export const Panel = styled.div`
  padding: 4px 12px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(
      269deg,
      rgba(255, 255, 255, 0.1) 0.57%,
      rgba(255, 255, 255, 0.05) 31.35%
    ),
    rgba(0, 0, 0, 0.6);
  display: inline-flex;
  gap: 7px;
  flex-wrap: wrap;
  position: relative;

  ${rpMediaQueries.tablet} {
    padding: 8px 16px;
    gap: 16px;
  }
`

export const Divider = styled.div`
  width: 1px;
  background: rgba(255, 255, 255, 0.29);
  align-self: stretch;
`

export const PanelInside = styled.div``
